<app-menu></app-menu>

<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="upload-container">
  <div class="container">
    <h1><strong>Primeiro, faça o upload do seu livro</strong></h1>
    <p>Comece sua jornada de autopublicação com a Feira do Livro. Envie seu manuscrito e siga nossos passos simples para
      levar seu livro aos leitores do mundo todo.</p>

    <div class="upload-area">
      <div class="upload-label" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)">
        <p><strong>Arraste e solte seu livro aqui</strong></p>
        <p>Nós trabalhamos com <b>.doc</b> e <b>.docx</b>. Tamanho máximo de <b>50Mb</b></p>
        <button type="button" class="upload-btn" (click)="fileInput.click()">Selecionar arquivo</button>
        <input id="fileInput" type="file" accept=".doc,.docx" hidden #fileInput (change)="onFileSelected($event)" />
      </div>
      <div *ngIf="selectedFile as file" class="upload-filename">{{ file.name }}</div>
      <div *ngIf="errorMessage" class="upload-error">{{ errorMessage }}</div>
      <div *ngIf="reselectedSameFile" class="upload-warning">
        O mesmo arquivo foi selecionado novamente. Nenhuma alteração detectada.
      </div>
      <div *ngIf="bookVerifyNotes.length > 0" class="upload-notes">
        <div class="notes-header">
          <mat-icon>error_outline</mat-icon>
          <div class="notes-title">
            <p>Seu livro precisa de ajustes antes de continuar:</p>
          </div>
        </div>

        <ul class="notes-list">
          <li *ngFor="let note of bookVerifyNotes">{{ note }}</li>
        </ul>
      </div>
      <div *ngIf="bookVerifyNotes.length > 0 || fileErrorCount > 0">
        <div class="notes-action">
          <button type="button" class="hire-btn" [disabled]="isUploading" (click)="hireFormatter()">
            Contratar diagramador
          </button>
        </div>
      </div>
    </div>

    <div class="upload-flow">
      <div class="upload-actions">
        <button type="button" class="back-btn">Voltar</button>
        <button type="button" class="continue-btn" [disabled]="!canProceed || isUploading"
          (click)="upload()"> {{ isUploading ? 'Enviando...' : 'Continuar' }}
        </button>
      </div>

      <div class="upload-steps">
        <h2>Veja os passos para publicar seu livro</h2>
        <div class="steps">
          <div class="step"><strong>Faça o upload</strong>
            <p>Envie facilmente o rascunho do seu livro com apenas alguns cliques.</p>
          </div>
          <div class="step"><strong>Crie e edite a sua capa</strong>
            <p>Com a ajuda da nossa I.A. especializada, crie a sua capa em segundos!</p>
          </div>
          <div class="step"><strong>Revise e publique</strong>
            <p>Preencha as informações do livro e nossos editores irão revisar a sua obra.</p>
          </div>
          <div class="step"><strong>Comece a vender!</strong>
            <p>Comece a ser reconhecido com seu trabalho</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>